import React from 'react'
import mainBG from '../../../assets/EinführungMainBG.png'
import ellipseBG from '../../../assets/EllipseBG.png'
import { useTranslation } from "react-i18next";
const SimrugGuide = ({ nextClick, backClick }) => {
    const { t } = useTranslation()
    return (
        <>
            <div style={{ background: `url(${mainBG})` }} className='h-screen !bg-cover !bg-no-repeat !bg-center flex flex-col justify-between'>
                <div className='font-bold text-base text-[#0F32C0E5] self-center italic py-8 text-center max-w-[380px]'>{t(`s-5-title`)}</div>
                <div style={{ background: `url(${ellipseBG})` }} className='min-h-[75vh] !bg-cover !bg-no-repeat !bg-top relative'>
                    <div className='relative pb-4 pt-36 w-full mx-auto max-w-[36rem] flex flex-col justify-between h-full justify-self-center text-center'>
                        <div>
                            <div className="bordered-text">
                                Discover the power in you!
                            </div>
                            <p className='text-center font-semibold text-white text-lg leading-9 mx-4'>
                                {t(`s-5-desc`)}

                            </p>
                        </div>

                        <div className='pt-4 flex gap-6 mx-4 flex-col-reverse sm:flex-row'>
                            <button className='w-full button_primary' onClick={backClick} >{t(`s-2-btn1`)}</button>
                            <button className='w-full button_secodry' onClick={nextClick} >{t(`s-2-btn2`)}</button>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default SimrugGuide